import React from 'react';
import { faCube } from '@fortawesome/pro-regular-svg-icons/faCube';
import {
  ELEMENT_TYPE,
  type DocumentElement as DocumentElementType,
} from '@eaco/forms-core';
import EntityPicker from './EntityPicker';
import { ENTITY_KINDS, assetSnapshot } from './entityKinds';
import { DOCUMENT_ELEMENT_ASSETS_QUERY } from './queries';

const AssetPicker: React.FC<{ element: DocumentElementType }> = ({
  element,
}) => (
  <EntityPicker
    element={element}
    query={DOCUMENT_ELEMENT_ASSETS_QUERY}
    collectionField="documentElementAssets"
    icon={faCube}
    iconColour="#6d4bf0"
    defaults={{
      label: 'Asset',
      placeholder: 'Search for an asset...',
    }}
    rowSubtitle={(row) =>
      (row.propertyName as string | null | undefined) || null
    }
    rowBadges={(row) => {
      const out: string[] = [];
      if (row.refId) out.push(`#${row.refId}`);
      if (row.customerName) out.push(String(row.customerName));
      return out;
    }}
    rowToSnapshot={assetSnapshot}
    contextSpec={ENTITY_KINDS[ELEMENT_TYPE.asset].contextSpec}
  />
);

export default AssetPicker;
